import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import FormSection from 'components/Layouts/Form/FormSection';
import LayoutWithFooter from 'components/Layouts/shared/LayoutWithFooter';
import Button from 'components/shared/Button';
import FormActions from 'components/shared/FormAdapters/FormDefault/FormActions';
import FormTitle from 'components/shared/Typography/FormTitle';
import useElementBottomPosition, { SNACKBAR_POSITION } from 'hooks/useElementBottomPosition';
import { useScrollPageToTop } from 'hooks/useScrollPageToTop';
import { itineraryRelocationsSelector } from 'store/itinerariesItem/relocations/selectors';
import { initializeRelocationsThunk, resetEmptyRelocationsThunk } from 'store/itinerariesItem/relocations/thunks';

import ItinerariesItemActionButtons from '../../ItinerariesItemBuilder/ActionButtons';
import { BuilderFooterButton } from '../../PageTypes/shared/BuilderFooterButton';
import { FlightsContextProvider } from './context';
import { FlightsTable } from './FlightsTable';
import s from './index.module.css';
import { useActions } from './useActions';
import { useFlights } from './useFlights';

function Flights() {
  useScrollPageToTop();
  useElementBottomPosition(SNACKBAR_POSITION);
  const dispatch = useDispatch();
  const [isSaving, setIsSaving] = React.useState(false);

  const { handleItemRemove, handleItemChange, handleSave, handleNextStep, handleItemEdit } = useActions();
  const items = useSelector(itineraryRelocationsSelector);
  const context = useFlights({
    items,
    onSave: handleSave,
    onItemChange: handleItemChange,
    onItemRemove: handleItemRemove,
    onNextStep: handleNextStep,
    onEdit: handleItemEdit,
  });

  const { handleSaveData, submitting, handleSubmit, handleFlightsClear } = context;

  React.useEffect(() => {
    dispatch(initializeRelocationsThunk({ createItemIfEmpty: true }));

    return () => {
      dispatch(resetEmptyRelocationsThunk());
    };
  }, [dispatch]);

  return (
    <LayoutWithFooter>
      {({ footerComponent: FooterComponent }) => (
        <FormSection popupLineShift="-2rem" className={s.s__section}>
          <div className={s.container}>
            <FormTitle center noBorder className={s.title}>
              Flights & Transfers
              <Button type="default" size="medium" className={s.titleButton} onClick={handleFlightsClear}>
                Clear All Flights
              </Button>
            </FormTitle>

            <FlightsContextProvider data={context}>
              <FlightsTable items={items} />
            </FlightsContextProvider>

            <FooterComponent>
              <FormActions isRight>
                <BuilderFooterButton
                  onClick={handleSubmit}
                  disabled={submitting || isSaving}
                  id="itineraryFlightsNextButton"
                >
                  Next
                </BuilderFooterButton>
              </FormActions>
            </FooterComponent>

            <ItinerariesItemActionButtons
              // hasValidationErrors={hasValidationErrors}
              submitting={submitting}
              onSave={handleSaveData}
              onIsSavingChange={setIsSaving}
            />
          </div>
        </FormSection>
      )}
    </LayoutWithFooter>
  );
}

export default Flights;
